export default () => import(/* webpackChunkName: 'coffee/activities/membership/draw-by-beans' */ './DrawByBeans');
